import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import MediaComponentManager from 'aria-viewer/media/components/mediaComponentManager'
import {
    prevPoint,
    nextPoint,
    setMainMediaInitialized,
    setMainMediaLoadingStatus,
    setMainMediaType,
    setMainMediaDimensions,
    showUIButton,
} from 'aria-viewer/tour/tourActions'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { FORWARD, setWalkingDirection, setEntryPoint } from 'aria-viewer/navigation/navigationActions'
import { MEDIA_TYPES, MEDIA_LOADING_STATUS } from 'aria-viewer/tour/constants'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { AUDIO_MAIN } from 'aria-viewer/audiomanager/audioManagerActions'
import { mainMediaClicked } from '../actions'
import compose from 'recompose/compose'

// TODO : logic in this component should be handled
// TODO   purely with reducers and actions

class MainMediaManager extends PureComponent {
    handleOnLoad = (e, element) => {
        const {
            mainMedia,
            mainMediaInitialized,
            setMainMediaInitialized,
            setMainMediaType,
            setMainMediaLoadingStatus,
            setMainMediaDimensions,
        } = this.props

        let isMediaInitialized

        switch (mainMedia.mediaType) {
            case MEDIA_TYPES.video:
            case MEDIA_TYPES.photo:
            case MEDIA_TYPES.panorama:
                isMediaInitialized = true
                break
            default:
                isMediaInitialized = false
                break
        }

        if (mainMediaInitialized != isMediaInitialized) {
            setMainMediaInitialized(isMediaInitialized)
        }

        setMainMediaType(mainMedia.mediaType)
        setMainMediaLoadingStatus(MEDIA_LOADING_STATUS.loaded)

        if (element && element.nodeName == 'IMG') {
            const { naturalWidth, naturalHeight } = element

            setMainMediaDimensions({ width: naturalWidth, height: naturalHeight })
        }
    }

    //this gets called for hybrid tours
    handleOnRotate = walkingDirection => {
        this.props.setWalkingDirection(null)

        //show the nav button after the pano has rotated in hybrid tours
        this.props.showUIButton(true)

        if (walkingDirection && !this.props.entryPoint) {
            walkingDirection === FORWARD ? this.props.nextPoint() : this.props.prevPoint()
        }
    }

    setMainMediaStatusToLoading = ({ mainMediaLoadingStatus }) => {
        if (mainMediaLoadingStatus !== MEDIA_LOADING_STATUS.loading) {
            this.props.setMainMediaLoadingStatus(MEDIA_LOADING_STATUS.loading)
        }
    }

    componentDidMount() {
        this.setMainMediaStatusToLoading({
            mainMediaLoadingStatus: this.props.mainMediaLoadingStatus,
        })
    }

    componentWillReceiveProps(props) {
        if (props.currentStop.stopid != this.props.currentStop.stopid) {
            this.setMainMediaStatusToLoading(props)
        }
    }

    render() {
        const {
            panoCoords,
            mainMedia,
            mainMediaInitialized,
            currentStop,
            altMainMedia,
            isStopIntroPlayed,
            style,
        } = this.props

        //if intro played on stop, dont play it again
        const hasIntro =
            currentStop.intro_media &&
            (!altMainMedia || altMainMedia.stopid != currentStop.stopid) &&
            !isStopIntroPlayed.get(currentStop.stopid)
        const secondaryOptions = {
            coordOptions: panoCoords,
            startCoord: {
                lat: mainMedia.start_lat,
                lon: mainMedia.start_lon,
            },
            mainMediaInitialized,
            hasIntro,
            delay: altMainMedia ? styleguide.delay.long : styleguide.delay.mainMediaTransition,
        }

        return (
            <MediaComponentManager
                audioType={AUDIO_MAIN}
                onLoad={this.handleOnLoad}
                onRotate={this.handleOnRotate}
                positionalmedia={this.props.positionalmedia}
                options={mainMedia}
                secondaryOptions={secondaryOptions}
                {...this.props}
            />
        )
    }
}

export default compose(
    connect(state => ({
        autoplay: state.getIn(['audioManager', 'autoplay']),
    })),
    connect(
        mapSelectorsToProps([
            'mainMedia',
            'panoCoords',
            'mainMediaInitialized',
            'mainMediaLoadingStatus',
            'currentStop',
            'altMainMedia',
            'entryPoint',
            'isStopIntroPlayed',
        ]),
        {
            prevPoint,
            nextPoint,
            setWalkingDirection,
            setMainMediaInitialized,
            setMainMediaLoadingStatus,
            setMainMediaType,
            setMainMediaDimensions,
            setEntryPoint,
            showUIButton,
            onClick: mainMediaClicked,
        }
    )
)(MainMediaManager)
